<template>
<div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
        <el-tabs>
            <!-- 附件解析设置 -->
            <el-tab-pane>
                <span slot="label">{{ $t("logs.role4") }}</span>
                <div class="lie">
                    <table>
                        <tbody>
                          
                            <tr>
                                <!-- 附件解析超时时间(秒) -->

                                <td>{{ $t("logs.autu5_a2") }}:</td>
                                <td style="display:flex; flex-direction:row">
                                    <el-input v-model="office_att_scan_timeout" placeholder=""></el-input>
                                    <el-alert :title="$t('logs.attachment9')" type="warning" show-icon :closable="false">
                                    </el-alert>

                                </td>
                            </tr>

                          
                         
                            <tr>
                                <td></td>
                                <td style="display:flex;flex-direction:row">
                                    <el-button type="primary" @click="save_greylist()">{{$t('logs.save_a')}}</el-button>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
             
            </el-tab-pane>

        </el-tabs>
    </div>
</div>
</template>

<script>
// import $ from "jquery";
export default {
    data() {
        return {
            ret_img:'',
            office_att_check: '',
            office_att_scan_max_msgsize: '',
            office_att_scan_max_cn: '',
            office_att_oneatt_max_size: '',
            office_att_scan_num: '',
            office_att_scan_timeout: '',
            textarea: "",
            input: "",
            time: new Date(2020, 9, 10, 18, 40),
            value1: "",

            tableData: [{
                address: "44",
            }, ],
            emali: "",
            value: "",
            checkList: [],
            tanchu: false,
            options: [{
                    value: "选项1",
                    label: "不使用TLS",
                },
                {
                    value: "选项2",
                    label: "增加信头标记",
                },
                {
                    value: "选项3",
                    label: "强制TLS",
                },
            ],
            checked: "",
            fileList: [],
            radio: [],
            data_loadok: '',
        };
    },
    mounted() {
        // this.getFileList1()
    },
    methods: {
        save_greylist() {

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            let str = this.$qs.stringify({
                __mode: "save_office_att_param",
                sid: sid,
                office_att_check: this.office_att_check == true ? 1 : 0,
                office_att_scan_max_msgsize: this.office_att_scan_max_msgsize,
                office_att_scan_max_cn: this.office_att_scan_max_cn,
                office_att_oneatt_max_size: this.office_att_oneatt_max_size,
                office_att_scan_num: this.office_att_scan_num,
                office_att_scan_timeout: this.office_att_scan_timeout,
                data_loadok: this.data_loadok

            });
            this.$axios
                .post("/api/adm/cgi/aspam.cgi", str)
                .then((res) => {
                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu_edit = false

                        this.getFileList1()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })
        },
        // 过滤单元加载
        getFileList1() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/index.cgi", {
                    params: {
                        __mode: "show_login",
                        sid: sid,
                    },
                })
                .then((res) => {
                    console.log(res);

                    if(!res){
             this.loading = false;
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
             this.loading = false;

                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                      this.fileList=res.data.ret.json.one
                      this.ret_img=res.data.ret.img

                    }
                })
               
        },
        // 显示
        tan: function () {
            this.tanchu = true;
        },
        // 打开关闭
        tanSend: function () {
            this.tanchu = false;
        },
        tanOff: function () {
            this.tanchu = false;
        },
    },
};
</script>

<style lang="less" scoped>
@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";

/deep/ .el-tabs__nav {
    padding-left: 14px;
}
</style>
